import {
    createUnknownComponentVNode as _$cc,
    createElementVNode as _$ce,
    className as _$cn,
    superCall as _$su,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    map as _$ma,
} from 'intact';
import {Dropdown, DropdownMenu, DropdownItem} from '../dropdown';
import {Icon} from '../icon';
import {_$} from '../../i18n';
import {makeMenuStyles, makeFilterMenuStyles} from './styles';

var _$tmp0 = {
    'className': 'ion-load-c k-cascader-loading',
    'rotate': true
};
var _$tmp1 = {
    'className': 'k-cascader-arrow ion-ios-arrow-right'
};
var _$tmp2 = {
    'className': 'k-cascader'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {data, trigger, filterable} = this.get();
    const baseMenuStyles = makeMenuStyles();
    const classNameObj = {
        'k-cascader-menu': true,
        [baseMenuStyles]: true,
    };
    
    const {values, isShowed, isSelected, onSelect, toggleShowedValue} = this.value;
    const Options = (data, level, loaded, parentSelected) => {
        if (!data.length) {
            if (!loaded) {
                return _$cc(Icon, _$tmp0)
            } else {
                return _$ce(2, 'div', _$('无数据'), 0, 'k-cascader-empty')
            }
        }
    
        return data.map((item, index) => {
            const value = item.value;
            const showed = isShowed(value, level);
            const selected = parentSelected && isSelected(value, level);
            const children = item.children;
    
            const Item = () => {
                return (
                    _$cc(DropdownItem, {
                        'disabled': item.disabled,
                        'className': _$cn({
                            'k-cascader-option': true,
                            'k-active': showed,
                            'k-selected': selected,
                        }),
                        'ev-select': onSelect.bind(null, value, level),
                        'children': [
                            item.label,
                            (children) ?
                                _$cc(Icon, _$tmp1) :
                                undefined
                        ]
                    })
                );
            };
    
            return (
                children ?
                    _$cc(Dropdown, {
                        'position': this.positionObj,
                        'of': 'parent',
                        'disabled': item.disabled,
                        'trigger': trigger,
                        'value': showed,
                        'ev-$changed:value': toggleShowedValue.bind(null, value, level),
                        'ev-show': this.load.bind(null, item),
                        'children': [
                            Item(),
                            _$cc(DropdownMenu, {
                                'className': _$cn(classNameObj),
                                'children': showed ? Options(children, level + 1, item.loaded, selected) : null
                            })
                        ]
                    }) :
                    Item()
            );
        });
    }
    
    const {filter, keywords: {value: keywords}, selectByFilter} = this.filterable;
    return _$su.call($this, _$tmp2, function($blocks) {
        var _$blocks = {}, __$blocks = _$ex({}, $blocks);
        return (
            (
                (_$blocks['base-menu'] = function($super) {
                    return (
                        (!filterable || !keywords) ?
                            _$cc(DropdownMenu, {
                                'className': _$cn(classNameObj),
                                'key': 'common',
                                'children': Options(data, 0, true, true)
                            }, 'common') :
                            _$cc(DropdownMenu, {
                                'key': 'filter',
                                'className': _$cn({
                                    'k-cascader-filter': true,
                                    [baseMenuStyles]: true,
                                    [makeFilterMenuStyles()]: true,
                                }),
                                'children': (() => {
                                    const items = filter();
                                    if (!items.length) return _$ce(2, 'div', _$('无匹配数据'), 0, 'k-cascader-empty')
                                
                                    return _$ma(items, function($value, $key) {
                                        return _$cc(DropdownItem, {
                                            'ev-select': selectByFilter.bind(null, $value),
                                            'disabled': $value.disabled,
                                            'children': (() => {
                                                // highlight keywords
                                                const label = $value.map(item => item.label).join(' / ');
                                                const labels = label.split(keywords);
                                                const length = labels.length; 
                                                return labels.map((item, index) => {
                                                    const ret = [item];
                                                    if (index !== length - 1) {
                                                        ret.push(_$ce(2, 'em', keywords, 0));
                                                    }
                                                    return ret;
                                                });
                                            })()
                                        });
                                    }, $this)
                                })()
                            }, 'filter')
                    );
                }),
                (__$blocks['base-menu'] = function($super, data) {
                    var block = $blocks['base-menu'];
                    var callBlock = function() {
                        return _$blocks['base-menu'].call($this, $super, data);
                    };
                    return block ?
                        block.call($this, callBlock, data) :
                        callBlock();
                })
            ),
            __$blocks
        );
    }.call($this, $blocks), $__proto__);
};